import * as React from 'react';
import DropDownFilter from './DropDownFilter';
import { SlicerOptionType } from '../types';

export interface Props {
  options?: SlicerOptionType[];
  variant?: string;
  onChange: (option: string, customRange?: Array<number | string>) => void;
}

const SlicerOptions: React.FC<Props> = ({ options, variant }) => {
  return (
    <>
      {options?.map((option, idx) => (
        <DropDownFilter
          key={idx}
          label={`${option.label}:`}
          options={['Category']}
          onChange={() => null}
          value="Category"
          variant={variant}
        />
      ))}
    </>
  );
};

export default SlicerOptions;
